import { DEFAULT_ADVANCE_BUTTON_STYLE, DEFAULT_CANCEL_BUTTON_STYLE } from '../../../../utils/styleHelpers';
import { ComponentSpinner } from '../../Loading/ComponentSpinner';
import { ManualSpendDraft } from './useManualSpendDraft';

export const ManualSpendActions = ({ draft }: { draft: ManualSpendDraft }) => (
  <div className="flex justify-end gap-3">
    <button
      type="button"
      className={DEFAULT_CANCEL_BUTTON_STYLE}
      disabled={!draft.changed || draft.saving}
      onClick={draft.cancel}>
      Cancel
    </button>
    <button
      type="button"
      className={DEFAULT_ADVANCE_BUTTON_STYLE}
      disabled={!draft.changed || draft.saving}
      onClick={draft.save}>
      {draft.saving ? <ComponentSpinner sx={{ height: '19px' }} /> : 'Save Line Items'}
    </button>
  </div>
);
